<template>
    <div class="row">
        
        <div class="col-12 mt-3">
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
                <label class="btn active" v-bind:class="{ 'btn-light': state.tab != 'clients', 'btn-danger active': state.tab == 'clients' }">
                    <input type="radio" name="options" v-on:click="state.tab = 'clients'" id="option1" autocomplete="off" checked> Client List
                </label>
                <label class="btn" v-bind:class="{ 'btn-light': state.tab != 'servers', 'btn-danger active': state.tab == 'servers' }">
                    <input type="radio" name="options" v-on:click="state.tab = 'servers'" id="option2" autocomplete="off"> Server List
                </label>
                <label class="btn" v-bind:class="{ 'btn-light': state.tab != 'contacts', 'btn-danger active': state.tab == 'contacts' }">
                    <input type="radio" name="options" v-on:click="state.tab = 'contacts'" id="option2" autocomplete="off"> Contacts
                </label>
            </div>
        </div>
        
        <div class="col-12" v-if="state.tab == 'servers'">
            <div class="col-12 m-2">
                <input v-model="serverSearch" placeholder="search servers..."  />
            </div>
            <p>Showing {{filteredServerList.length}} EC2 Servers of {{rawServers.length}}</p>
            <div class="row justify-content-center" >
                <div class="col-6 col-lg-3 col-xs-6  m-lg-2 mb-xs-2" v-for="server in filteredServerList" v-bind:key="server.Name" v-on:click="GoToServerSummary(server)">
                    <div class="server">
                        <div class="server__statuscontainer mx-auto">
                            <span class="server__statuscontainer__status" v-bind:class="'server__statuscontainer__status--' + server.State.Name"></span>
                            <img src="../assets/server.png" width="50" >
                        </div>
                        <div class="server__label">{{server.Name}}</div>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-12" v-else-if="state.tab == 'clients'">
            <div class="container">
                <div class="row">
                    <div class="col-12 m-2">
                        <input v-model="clientSearch" placeholder="search clients..." />
                    </div>
                    <div class="col-12">
                        <p>Showing {{filteredClientList.length}} Clients of {{rawClients.length}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6" v-for="client in filteredClientList" v-bind:key="client.Name">
                        <div class="card m-2">
                            <div class="card-header">
                                <h5>{{client.Name}}</h5>      
                            </div>
                            <div class="container">
                                <div class="row">
                                    <div class="col-6 col-xs-6 col-md-4 col-lg-3 p-2 mx-auto" v-for="server in client.Servers" v-bind:key="server.Name" v-on:click="GoToServerSummary(server)">
                                        <div class="server h-100">
                                            <div class="server__statuscontainer mx-auto">
                                                <span class="server__statuscontainer__status" v-bind:class="'server__statuscontainer__status--' + server.State.Name"></span>
                                                <img src="../assets/server.png" width="50" >
                                            </div>
                                            <div class="server__label">{{server.Name}}</div>
                                            <div class="server__environment">{{server.Environment}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12" v-else-if="state.tab == 'contacts'">
            <div class="row">
                <div class="container">
                    <div class="grid_12">
                        <h3 class="m-3">Developers</h3>
                        <table class="table">
                            <thead>
                                <tr><th>Name</th><th>Number</th><th></th></tr>
                            </thead>
                            <tbody>
                                <tr v-for="contact in contacts.Developers" v-bind:key="contact.Name">
                                    <td>{{contact.Name}}</td>
                                    <td>{{contact.Tel}}</td>
                                    <td><a :href="'tel:' + contact.Tel">Call</a></td>
                                </tr>
                            </tbody>
                        </table>

                        <br/><br/>
                        <h3 class="m-3">Client Support</h3>
                        <table class="table">
                            <thead>
                                <tr><th>Name</th><th>Number</th><th></th></tr>
                            </thead>
                            <tbody>
                                <tr v-for="contact in contacts.AccountManagers" v-bind:key="contact.Name">
                                    <td>{{contact.Name}}</td>
                                    <td>{{contact.Tel}}</td>
                                    <td><a :href="'tel:' + contact.Tel">Call</a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { HomeState } from '../app/appstate'
import UserInfoStore from '../app/user-info-store';
import serverStore from '../app/server-store';
import IndexRouter from '../router/index';
const _ = require('lodash');

export default {
    name: 'Home',
    data: function() {
        let data = {
            userInfo: UserInfoStore.state.cognitoInfo,
            state: HomeState,
            rawClients: [],
            rawServers: [],
            clientSearch: '',
            serverSearch: '',
            contacts: { Developers: [], AccountManagers: [] }
        };

        serverStore.getServers().then(servers => {
            data.rawServers = _.orderBy(servers, 'Name', 'asc');

            for(var server of servers) {
                if(server.Clients.length == 0)
                    continue;

                for(var clientName of server.Clients) {
                    let client = data.rawClients.find(c => c.Name == clientName);

                    if(typeof(client) == "undefined") {
                        data.rawClients.push(client = {
                            Name: clientName,
                            Servers: []
                        })
                    }
                    
                    client.Servers.push(server);
                }
            }

            data.rawClients = _.orderBy(data.rawClients, 'Name', 'asc');
        })

        serverStore.getServerSupportContacts().then(contacts => {
            data.contacts = contacts;
        })

        return data;
    },
    methods: {
        GoToServerSummary : (server) => {
            IndexRouter.push(`/server/${server.Region}/${server.InstanceId}`)
        }
    },
    computed: {
        filteredClientList() {
            return this.rawClients.filter(client => {
                return client.Name.toLowerCase().includes(this.clientSearch.toLowerCase())
            })
        },
        filteredServerList() {
            return this.rawServers.filter(server => {
                return server.Name.toLowerCase().includes(this.serverSearch.toLowerCase())
            })
        }
    }
}
</script>
<style lang="scss">
    .server {
        transition: 0.2s linear all;
        border:1px solid white;
        border-radius: 10px;
        cursor: pointer;
        position: relative;
        margin-bottom: 15px;

        &:hover {
            background: #f2f2f2;
            border: 1px solid #a8a8a8;
        }

        &__statuscontainer {
            position: relative;
            width: 50px;

            &__status {
                background: white;
                width: 12px;
                height: 12px;
                display: inline-block;
                border-radius: 10px;
                margin-bottom: -5px;
                -webkit-transition: background-color 1000ms linear;
                transition: background-color 1000ms linear;
                position: absolute;
                top: -1px;
                left: 4px;
                animation: pulse 3s infinite ease-in-out;

                &--stopping { 
                    background: orange;
                }

                &--stopped {
                    background: red; 
                }

                &--pending {
                    background: #cbff4e;
                }

                &--running {
                    background: #03db00;
                }
            }
        }

        &__label {
            font-size: 9pt;
            word-break:break-word;
        }

        &__environment {
            background: grey;
            color: white;
            font-size: 6pt;
            border-radius: 0 0 5px 5px;
            position: absolute;
            bottom:0;
            left:0;
            right:0;
        }
    }

    @keyframes pulse {
        0% {  opacity: 0.5; }
        50% {  opacity: 1; }
        100% {  opacity: 0.5; }
    }
</style>